exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cvat-feedback-button{position:fixed;bottom:20px;right:20px;padding:0;height:auto}.cvat-feedback-button>i{font-size:40px}\n", ""]);
